import { useCallback, useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { parseBoolean } from '../utils/parseBoolean';

export const useFeatureChecker = () => {
  const features = useFlags();

  const checkFeature = useCallback(
    (featureId) => {
      const feature = features?.[featureId];

      return parseBoolean(feature);
    },
    [features]
  );

  return { checkFeature };
};

export const useFeature = (featureId) => {
  const { checkFeature } = useFeatureChecker();

  const hasFeature = useMemo(() => checkFeature(featureId), [checkFeature, featureId]);

  return [hasFeature];
};
